import {
  HotelChangeQuoteReq,
  HotelChangeQuoteRes,
  LodgingChangeQuoteResEnum,
  NETWORK_CALL_FAILED,
  Uuid,
} from "@hopper-b2b/types";

import { axiosInstance } from "../AxiosInterceptor";
import { getHotelChangeQuoteAnyPath } from "../paths";
import { trackEvent } from "../tracking/trackEvent";

/**
 * @description The first of two endpoints in the self serve cancel hotels flow
 * @param {Uuid} reservationId
 * @return {CancelScenario} The cancellation info for the reservation passed in
 */
const getHotelChangeQuoteAny = async (reservationId: Uuid) => {
  try {
    const req: HotelChangeQuoteReq = {
      reservationId,
    };
    const res = await axiosInstance.post<HotelChangeQuoteRes>(
      getHotelChangeQuoteAnyPath,
      req
    );

    if (res.data) {
      const { LodgingChangeQuoteResponse } = res.data;

      if (
        LodgingChangeQuoteResponse === LodgingChangeQuoteResEnum.Success ||
        LodgingChangeQuoteResponse === LodgingChangeQuoteResEnum.NonCartSuccess
      ) {
        return res.data;
      }
    }

    throw res;
  } catch (err) {
    trackEvent({
      eventName: NETWORK_CALL_FAILED,
      properties: {
        location: window.location.pathname,
      },
    });

    throw err;
  }
};

export default getHotelChangeQuoteAny;
